import { Routes } from '@angular/router';
import { ngxPermissionsGuard } from 'ngx-permissions';

export const BOT_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'users',
  },
  {
    path: 'users',
    loadComponent: () => import('../users/users.component').then((m) => m.UsersComponent),
    canMatch: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: ['UsersPage'],
        redirectTo: '/',
      },
    },
  },
  {
    path: 'triggers',
    loadComponent: () => import('../triggers/triggers.component').then((m) => m.TriggersComponent),
    canMatch: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: ['FlowEditorPage'],
        redirectTo: '/',
      },
    }
  },
  {
    path: 'flows',
    loadChildren: () => import('../flows/flows.routes').then((m) => m.FLOWS_ROUTES),
    canMatch: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: ['FlowEditorPage'],
        redirectTo: '/',
      },
    }
  },
  {
    path: 'campaigns',
    loadComponent: () => import('../campaigns/campaigns.component').then((m) => m.CampaignsComponent),
    canMatch: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: ['CampaignsPage'],
        redirectTo: '/',
      },
    }
  },
  {
    path: 'analytics',
    loadComponent: () => import('../analytics/analytics.component').then((m) => m.AnalyticsComponent),
    canMatch: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: ['AnalyticsPage'],
        redirectTo: '/',
      },
    }
  },
  {
    path: 'feedbacks',
    loadComponent: () => import('../feedbacks/feedbacks.component').then((m) => m.FeedbacksComponent),
    canMatch: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: ['FeedbacksPage'],
        redirectTo: '/',
      },
    }
  },
  {
    path: 'settings',
    loadChildren: () => import('../settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
    canMatch: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: ['BotSettingsPage'],
        redirectTo: '/',
      },
    }
  },
];
